import { useMemo } from 'react';
import { useIteroPatientOrders } from '../../../../../hooks/useIteroBrowse';
import type { IteroOrder } from '../../../../../services/iteroBrowse';
import { browseErrorText } from '../browseErrorText';
import { useIteroBrowserScope } from '../iteroBrowserScope';
import { ordersForChart, patientOrdersParams } from '../orderQuery';
import { timelineOrders } from './profileFormat';

export interface PatientScanHistory {
    orders: readonly IteroOrder[];
    hasMore: boolean;
    isPending: boolean;
    errorMessage: string | null;
    retry: () => void;
}

// A blank chart leaves the query disabled: iTero can't look a patient's orders up any other way.
export function usePatientScanHistory(chartNumber: string): PatientScanHistory {
    const scope = useIteroBrowserScope();
    const params = useMemo(() => patientOrdersParams(chartNumber), [chartNumber]);
    const query = useIteroPatientOrders(scope, params);
    const orders = useMemo(
        () => (query.data ? timelineOrders(ordersForChart(query.data.orders, chartNumber)) : []),
        [query.data, chartNumber]
    );

    return {
        orders,
        hasMore: query.data?.hasMore ?? false,
        isPending: query.isPending,
        errorMessage: query.isError
            ? browseErrorText(query.error, "Couldn't load this patient's scans")
            : null,
        retry: () => void query.refetch()
    };
}
